import { Injectable } from '@angular/core';
import { MdbModalService } from 'mdb-angular-ui-kit/modal';
import { GoogleRegistrationDialogComponent } from 'src/app/components/google-registration-dialog/google-registration-dialog.component';
import { MdbToastService } from '../mdb-toast';

@Injectable({
  providedIn: 'root',
})
export class GoogleRegistrationService {
  constructor(
    private modalService: MdbModalService,
    private toast: MdbToastService
  ) {}

  async openRegistrationDialog(): Promise<void> {
    const modalRef = this.modalService.open(GoogleRegistrationDialogComponent, {
      modalClass: 'modal-dialog-centered',
      ignoreBackdropClick: true,
      keyboard: false,
    });

    modalRef.onClose.subscribe((result: any) => {
      if (result?.cancelled) {
        this.toast.info('Registrierung abgebrochen.');
      }
    });
  }
}
